
const QueryString = window.location.search; 
const urlParams = new URLSearchParams(QueryString); 
var formfieldVar = urlParams.get('formfieldID');

if(formfieldVar == "1"){
  document.getElementById("reason").selectedIndex = "1";
  //console.log("switch1");
}else if(formfieldVar == "2"){
  document.getElementById("reason").selectedIndex = "2";
  //console.log("switch2");
}else if(formfieldVar == "3"){
  document.getElementById("reason").selectedIndex = "3";
  //console.log("switch3");
}else{

}